<template>
<div ref="subGlobal" class="global-main global-shadow">

  <!-- ---------------------- 索引表格 ---------------------- -->
  
  <div class='global-panel' v-loading.body="loading.main">
    <div class='global-header'>
      <div class='global-title'>工作流引擎</div>
      <div class='global-tbar'>

      </div>
    </div>
    <hr>
    <div class='global-body'>
      <el-row>
        <el-col :span="7">
          <div class='global-title' style="width:100%;margin-bottom: 5px">
            <span style="line-height:30px;">流程列表</span>
            <el-button size="mini" round type="primary" @click="insertWorkFlow">新增</el-button>
            <el-button size="mini" round type="default" @click="findWorkFlow()">刷新</el-button>
          </div>
          <div ref="workFlowTable" style="overflow:scroll;width:100%;">
            <el-table :data="workFlows" border stripe style="width: 100%" size="mini"
                      highlight-current-row
                      @current-change="handleWorkFlowChange">
              <el-table-column prop="name" label="流程名" min-width="150"></el-table-column>
              <el-table-column label="操作" width="150" align="center">
                <template slot-scope="scope">
                  <el-button size="mini" type="text" @click="editWorkFlow(scope.row)">编辑</el-button>
                  <el-button class="global-text-btn-danger" size="mini" type="text" @click="removeWorkFlow(scope.row)" style="margin-left: 10px;">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
        <el-col :span="10">
          <div class='global-title' style="width:100%;margin-bottom: 5px">
            <span style="line-height:30px;">流程内容</span>
            <el-button size="mini" round type="primary" @click="insertContent">新增</el-button>
          </div>
          <div ref="contentTable" style="overflow:scroll;width:100%;">
            <el-table :data="workFlowContents" border stripe style="width: 100%" size="mini">
              <el-table-column prop="currentStatus" label="原状态" min-width="80"></el-table-column>
              <el-table-column prop="operation" label="动作" min-width="120"></el-table-column>
              <el-table-column prop="nextStatus" label="目标状态" min-width="80"></el-table-column>
              <el-table-column label="操作" width="150" align="center">
                <template slot-scope="scope">
                  <el-button size="mini" type="text" @click="editContents(scope.row)">编辑</el-button>
                  <el-button class="global-text-btn-danger" size="mini" type="text" @click="removeContents(scope.row)" style="margin-left: 10px;">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
        <el-col :span="7">
          <div class='global-title' style="width:100%;margin-bottom: 5px">
            <span style="line-height:30px;">流程状态</span>
            <el-button size="mini" round type="primary" @click="insertStatus">新增</el-button>
          </div>
          <div ref="statusTable" style="overflow:scroll;width:100%;">
            <el-table :data="workFlowStatus" border stripe style="width: 100%" size="mini">
              <el-table-column prop="orderNum" label="排序" min-width="50"></el-table-column>
              <el-table-column prop="name" label="状态名称" min-width="100"></el-table-column>
              <el-table-column label="操作" width="150" align="center">
                <template slot-scope="scope">
                  <el-button size="mini" type="text" @click="editStatus(scope.row)">编辑</el-button>
                  <el-button class="global-text-btn-danger" size="mini" type="text" @click="removeStatus(scope.row)" style="margin-left: 10px;">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
  
  <!-- ---------------------- 编辑弹窗 ---------------------- -->

  <!-- ---------------------- 工作流 ---------------------- -->
  <el-dialog :visible.sync="visible.editWorkFlowDialog" width="400px" :close-on-click-modal="false" :close-on-press-escape="false">
    <div v-loading="loading.editWorkFlowDialog">
      <el-form ref="workFlowForm" :model="currentWorkFlow" :rules="workFlowRules" label-width="70px" size="small">
        <el-form-item label="流程名" prop="name">
          <el-input v-model="currentWorkFlow.name"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input type="textarea" v-model="currentWorkFlow.note"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button size="small" type="primary" @click="saveWorkFlow" style="width: 220px;margin-left: 60px">保存</el-button>
        <el-button size="small" type="default" @click="visible.editWorkFlowDialog=false">取消</el-button>
      </div>
    </div>
  </el-dialog>
  <!-- ---------------------- 工作流内容 ---------------------- -->
  <el-dialog :visible.sync="visible.editContentDialog" width="400px" :close-on-click-modal="false" :close-on-press-escape="false">
    <div v-loading="loading.editContentDialog">
      <el-form ref="contentForm" :model="currentContent" :rules="contentRules" label-width="70px" size="small">
        <el-form-item label="源状态" prop="currentStatus">
          <el-select size="small" v-model="currentContent.currentStatus">
            <el-option v-for="item in workFlowStatus" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="操作" prop="operation">
          <el-input v-model="currentContent.operation"></el-input>
        </el-form-item>
        <el-form-item label="目标状态" prop="nextStatus">
          <el-select size="small" v-model="currentContent.nextStatus">
            <el-option v-for="item in workFlowStatus" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input type="textarea" v-model="currentContent.note"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button size="small" type="primary" @click="saveContent" style="width: 220px;margin-left: 60px">保存</el-button>
        <el-button size="small" type="default" @click="visible.editContentDialog=false">取消</el-button>
      </div>
    </div>
  </el-dialog>
  <!-- ---------------------- 工作流状态 ---------------------- -->
  <el-dialog :visible.sync="visible.editStatusDialog" width="400px" :close-on-click-modal="false" :close-on-press-escape="false">
    <div v-loading="loading.editStatusDialog">
      <el-form ref="statusForm" :model="currentStatus" :rules="statusRules" label-width="70px" size="small">
        <el-form-item label="排序" prop="orderNum">
          <el-input v-model="currentStatus.orderNum"></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="currentStatus.name"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input type="textarea" v-model="currentStatus.note"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button size="small" type="primary" @click="saveStatus" style="width: 220px;margin-left: 60px">保存</el-button>
        <el-button size="small" type="default" @click="visible.editStatusDialog=false">取消</el-button>
      </div>
    </div>
  </el-dialog>
  
</div>
</template>

<script>

export default {
  name: 'WorkFlowIndex',
  data () {
    return {
      // 工作流列表
      workFlows:[],
      // 工作流内容
      workFlowContents: [],
      // 工作流状态
      workFlowStatus: [],
      // 遮罩
      loading: {main: false, editWorkFlowDialog: false, editContentDialog: false, editStatusDialog: false},
      // 可见
      visible: {editWorkFlowDialog: false, editContentDialog: false, editStatusDialog: false},
      // 选中工作流
      currentWorkFlow:{},
      // 选中工作流内容
      currentContent:{},
      // 选中工作流状态
      currentStatus:{},
      // 校验规则
      workFlowRules: {
        name: [
          { required: true, message: '该项必填', trigger: 'change' },
          { max: 50, message: '长度最多50个字符', trigger: 'change' }
        ],
        note: [
          { max: 200, message: '长度最多200个字符', trigger: 'change' }
        ]
      },
      contentRules: {
        operation: [
          { required: true, message: '该项必填', trigger: 'change' },
          { max: 50, message: '长度最多50个字符', trigger: 'change' },
        ],
        note: [
          { max: 200, message: '长度最多200个字符', trigger: 'change' }
        ]
      },
      statusRules: {
        orderNum: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        name: [
          { required: true, message: '该项必填', trigger: 'change' },
          { max: 50, message: '长度最多50个字符', trigger: 'change' },
        ],
        note: [
          { max: 200, message: '长度最多200个字符', trigger: 'change' }
        ]
      }
    }
  },
  
  /*
   * 初始化
   */
  mounted: function () {
    var vm = this;
    vm.$refs.subGlobal.style.height = (window.innerHeight-vm.$baize.frameTitleHeight)+'px';
    vm.$refs.workFlowTable.style.height = (window.innerHeight-vm.$baize.frameTitleHeight-130)+'px';
    vm.$refs.contentTable.style.height = (window.innerHeight-vm.$baize.frameTitleHeight-130)+'px';
    vm.$refs.statusTable.style.height = (window.innerHeight-vm.$baize.frameTitleHeight-130)+'px';
    vm.findWorkFlow();
  },
  
  methods: {
    /**
     * 查询工作流
     */
    findWorkFlow: function () {
      var vm = this;
      // 开启遮罩
      vm.loading.main = true;
      // 请求后台
      vm.$http.get('rest/sys/goblinSM/findGoblinSM').then(response => {
        vm.workFlows = response.body;
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
      }, response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    /**
     * 工作流选中
     */
    handleWorkFlowChange: function (val) {
      let vm = this
      if(val!=null){
        vm.currentWorkFlow = val;
        vm.findContents();
      } else {
        vm.currentWorkFlow = {};
      }
    },
    /**
     * 查询工作流内容，状态
     */
    findContents: function () {
      var vm = this;
      // 开启遮罩
      vm.loading.main = true;
      var params = {"id":vm.currentWorkFlow.id}
      // 请求后台
      vm.$http.get('rest/sys/goblinSM/findContents', {params: params}).then(response => {
        vm.workFlowContents = response.body.contents;
        vm.workFlowStatus = response.body.status;
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
      }, response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },

    /**
     * 新增工作流
     */
    insertWorkFlow: function () {
      var vm = this
      vm.visible.editWorkFlowDialog = true
      vm.currentWorkFlow = {}
    },
    
    /**
     * 编辑工作流
     */
    editWorkFlow: function (record) {
      var vm = this
      vm.visible.editWorkFlowDialog = true
      vm.currentWorkFlow = record;
    },

    /**
     * 保存工作流
     */
    saveWorkFlow() {
      var vm = this;
      // 校验
      vm.$refs['workFlowForm'].validate((valid) => {
        if (!valid) {
          // 提示信息
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 获取焦点
          vm.$nextTick(() => {
            vm.$refs['workFlowForm'].$el.getElementsByClassName('is-error')[0].getElementsByTagName('input')[0].focus();
          })
          return false;
        }
        // 开启遮罩
        vm.loading.editWorkFlowDialog = true;
        // 调用后台
        vm.$http.post('rest/sys/goblinSM/saveGoblinSM', vm.currentWorkFlow).then(function (response) {
          vm.currentWorkFlow = response.body;
          // 关闭遮罩
          vm.loading.editWorkFlowDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
          // 关闭弹窗并重新查询
          vm.visible.editWorkFlowDialog = false;
          vm.findWorkFlow()
        }, response => {
          // 关闭遮罩
          vm.loading.editWorkFlowDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        });
      });
    },

    /**
     * 删除工作流
     */
    removeWorkFlow: function (record) {
      var vm = this;
      vm.$confirm('确定要删除[' + record.name +']流程吗？', '提示', {type: 'warning', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.main = true;
        var params = {"id":record.id}
        // 请求后台
        vm.$http.delete('rest/sys/goblinSM/deleteGoblinSM', {params: params}).then(function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          vm.findWorkFlow()
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },

    /**
     * 新增工作流内容
     */
    insertContent: function () {
      var vm = this
      if(vm.currentWorkFlow.id==null){
        // 提示
        vm.$alert('未选择工作流', '提示',{type:'error'});
        return;
      }
      vm.visible.editContentDialog = true
      vm.currentContent = {"goblinSm":vm.currentWorkFlow.id}
    },

    /**
     * 编辑工作流内容
     */
    editContents: function (record) {
      var vm = this
      if(vm.currentWorkFlow.id==null){
        // 提示
        vm.$alert('未选择工作流', '提示',{type:'error'});
        return;
      }
      vm.visible.editContentDialog = true
      vm.currentContent = record;
    },

    /**
     * 保存工作流内容
     */
    saveContent() {
      let vm = this;
      if(vm.currentWorkFlow.id==null){
        // 提示
        vm.$alert('未选择工作流', '提示',{type:'error'});
        return;
      }
      // 校验
      vm.$refs['contentForm'].validate((valid) => {
        if (!valid) {
          // 提示信息
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 获取焦点
          vm.$nextTick(() => {
            vm.$refs['contentForm'].$el.getElementsByClassName('is-error')[0].getElementsByTagName('input')[0].focus();
          })
          return false;
        }
        // 开启遮罩
        vm.loading.editContentDialog = true;
        // 调用后台
        vm.$http.post('rest/sys/goblinSM/saveGoblinSMContent', vm.currentContent).then(function (response) {
          vm.currentContent = response.body;
          // 关闭遮罩
          vm.loading.editContentDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
          // 关闭弹窗并重新查询
          vm.visible.editContentDialog = false;
          vm.findContents()
        }, response => {
          // 关闭遮罩
          vm.loading.editContentDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        });
      });
    },

    /**
     * 删除工作流内容
     */
    removeContents: function (record) {
      var vm = this;
      vm.$confirm('确定要删除[' + record.operation + ']吗？', '提示', {type: 'warning', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.main = true;
        // 请求后台
        var params = {"id":record.id}
        // 请求后台
        vm.$http.delete('rest/sys/goblinSM/deleteGoblinSMContent', {params: params}).then(function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          vm.findContents()
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },

    /**
     * 新增工作流状态
     */
    insertStatus: function () {
      var vm = this;
      if(vm.currentWorkFlow.id==null){
        // 提示
        vm.$alert('未选择工作流', '提示',{type:'error'});
        return;
      }
      vm.visible.editStatusDialog = true;
      vm.currentStatus = {"goblinSm":vm.currentWorkFlow.id};
    },

    /**
     * 编辑工作流状态
     */
    editStatus: function (record) {
      var vm = this;
      if(vm.currentWorkFlow.id==null){
        // 提示
        vm.$alert('未选择工作流', '提示',{type:'error'});
        return;
      }
      vm.visible.editStatusDialog = true
      vm.currentStatus = record;
    },

    /**
     * 保存工作流状态
     */
    saveStatus() {
      var vm = this;
      if(vm.currentWorkFlow.id==null){
        // 提示
        vm.$alert('未选择工作流', '提示',{type:'error'});
        return;
      }
      // 校验
      vm.$refs['statusForm'].validate((valid) => {
        if (!valid) {
          // 提示信息
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 获取焦点
          vm.$nextTick(() => {
            vm.$refs['statusForm'].$el.getElementsByClassName('is-error')[0].getElementsByTagName('input')[0].focus();
          })
          return false;
        }
        // 开启遮罩
        vm.loading.editStatusDialog = true;
        // 调用后台
        vm.$http.post('rest/sys/goblinSM/saveGoblinSMStatus', vm.currentStatus).then(function (response) {
          vm.currentStatus = response.body;
          // 关闭遮罩
          vm.loading.editStatusDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
          // 关闭弹窗并重新查询
          vm.visible.editStatusDialog = false;
          vm.findContents()
        }, response => {
          // 关闭遮罩
          vm.loading.editStatusDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        });
      });

    },

    /**
     * 删除工作流状态
     */
    removeStatus: function (record) {
      var vm = this;
      vm.$confirm('确定要删除状态[' + record.name + ']吗？', '提示', {type: 'warning', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.main = true;
        // 请求后台
        var params = {"id":record.id}
        vm.$http.delete('rest/sys/goblinSM/deleteGoblinSMStatus', {params: params}).then(function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          vm.findContents()
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    }
  }
}
</script>

<style>
.global-main {
  padding: 5px 0;
  position: relative;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/system/workflow/WorkFlowIndex.vue